import { useCallback, useContext, useState } from "react";

import question from "../../assets/question.svg";

import LeftHomeComponent from "../../components/leftHomeComponent/LeftHomeComponent";
import MainHomeComponent from "../../components/MainHomeComponent/MainHomeComponent";
import RightHomeComponent from "../../components/RightHomeComponent/RightHomeComponent";

import LoadingFullPage from "../../components/Loading/LoadingFullPage/LoadingFullPage";

import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { useGetPlanOptions } from "../../hooks/useGetPlanOptions";
import { Radio, RadioGroup } from "../../components/Radio/Radio";

import ButtonComponent from "../../components/ButtonComponent";
import { useNavigate } from "react-router-dom";
import { getLocalStorage } from "../../utils/localStorage";
import { SessionContext } from "../../context/session";
import { FluxoType } from "../../stores/tenant/tenant.types";

export const ChoosePlanOption = () => {
  const { type } = useTenantStore();
  const { setItemSession, getItemSession } = useContext(SessionContext);

  const localStoragePath = getLocalStorage("path");
  const planId = getItemSession("planId");
  const distribuidoraId = getItemSession("distribuidora");

  const [plan, setPlan] = useState(planId || "");

  const navigate = useNavigate();

  const { texts, assets, partnerId } = useTenantStore();
  const { data, ...getPlanOptionsRequestCtx } = useGetPlanOptions({
    parceiroId: partnerId!,
    distribuidoraId: distribuidoraId || "",
  });

  const handleChoosePlan = useCallback(
    (planId: string): void => {
      setItemSession("planId", planId);
      setItemSession("plan", JSON.stringify(data?.plans.find((item) => item.id === planId)));
      navigate("/contact");
    },
    [setItemSession, navigate, data?.plans]
  );

  const handleBack = useCallback((): void => {
    if (localStoragePath) {
      navigate(localStoragePath);
      return;
    }

    if (type === FluxoType.CONSULTOR) {
      navigate("/distribuidora");
      return;
    }

    navigate("/");
  }, [navigate, localStoragePath, type]);

  return (
    <MainHomeComponent>
      <LeftHomeComponent title={texts.choosePlan.title} description={texts.choosePlan.description} imgSrc={assets.choosePlan.image} />
      <RightHomeComponent questionSrc={question} title={texts.choosePlan.title} description={texts.choosePlan.description}>
        <div className="h-full max-w-[280px] w-full *:bg-transparent font-kumbh-sans flex flex-col justify-center">
          <div>
            <RadioGroup onValueChange={setPlan} value={plan} defaultValue={planId}>
              {data &&
                "plans" in data &&
                data.plans.map((planOption) => (
                  <Radio key={planOption.id} value={planOption.id} selectedValue={plan} isSelected={plan === planOption.id}>
                    {planOption.desconto}% de economia
                  </Radio>
                ))}
            </RadioGroup>
          </div>

          <div className="w-full flex justify-center items-center mt-4 min-h-[56px]">
            <div className="flex gap-4">
              <ButtonComponent className="back-button" onClick={handleBack}>
                Voltar
              </ButtonComponent>
              <ButtonComponent className="continue-button" isDisabled={!plan} onClick={() => (plan ? handleChoosePlan(plan) : null)}>
                Continuar
              </ButtonComponent>
            </div>
          </div>
        </div>
        {getPlanOptionsRequestCtx.isLoading && <LoadingFullPage />}
      </RightHomeComponent>
    </MainHomeComponent>
  );
};
